import { Component, Input } from '@angular/core';
import { Order } from '@usf/ngrx-order';

@Component({
  selector: 'app-order-confirmation-special-instructions',
  templateUrl: './order-confirmation-special-instructions.component.html',
  styleUrls: ['./order-confirmation-special-instructions.component.scss'],
})
export class OrderConfirmationSpecialInstructionsComponent {
  @Input() order: Order;

  get isRouted(): boolean {
    return this.order?.orderHeader?.orderType === 'RT';
  }

  get isVendorShip(): boolean {
    return this.order?.orderHeader?.orderType === 'VS';
  }

  get isWithoutSpecialInstructions(): boolean {
    return !this.order?.orderHeader?.specialDeliveryInstructions;
  }

  get isWithSpecialInstructions(): boolean {
    return !!this.order?.orderHeader?.specialDeliveryInstructions;
  }
}
